export default "__VITE_ASSET__72258789__"